export default __webpack_public_path__ + "static/media/banner_5.d1c15f6f.png";